export default "__VITE_ASSET__DvQ2Y5SO__"